import React from 'react';

import AccountLoader from './AccountLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';

import styles from './Account.module.scss';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Divider from '../../Shared/UI/Divider/components/Divider';
import EmailPageSectionTitle from './EmailPageSectionTitle';
import AccountEmail from './AccountEmail';
import PasswordPageSectionTitle from './PasswordPageSectionTitle';
import AccountPassword from './AccountPassword';
import AccountPaymentMethod from './AccountPaymentMethod';
import AccountSubscription from './AccountSubscription';
import CloseAccountPageSectionTitle from './CloseAccountPageSectionTitle';
import AccountClose from './AccountClose';
import AccountEmailUpdateModal from './AccountEmailUpdateModal';
import AccountPasswordUpdateModal from './AccountPasswordUpdateModal';
import AccountCloseModal from './AccountCloseModal';

const Account = ({ stripePublishableKey }) => {
  return (
    <>
      <AccountLoader stripePublishableKey={stripePublishableKey} />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="Manage Account" />
          <Divider />
          <EmailPageSectionTitle />
          <AccountEmail />
          <Divider />
          <PasswordPageSectionTitle />
          <AccountPassword />
          <Divider />
          <AccountPaymentMethod />
          <Divider />
          <AccountSubscription />
          <Divider />
          <CloseAccountPageSectionTitle />
          <AccountClose />
        </Stack>
      </div>
      <AccountEmailUpdateModal />
      <AccountPasswordUpdateModal />
      <AccountCloseModal />
    </>
  );
};

export default Account;
